import {createSlice} from "@reduxjs/toolkit";

export const workoutSetup = createSlice({
  name: 'workoutSetupData',
  initialState: {
    exerciseName: '',
    difficulty: '',
    character: '',
    music: '',
  },
  reducers: {
    createWorkoutSetupData: (state, {payload}) => {
      const {exerciseName, difficulty, character, music} = payload;

      state.exerciseName = exerciseName;
      state.difficulty = difficulty;
      state.character = character;
      state.music = music;

      localStorage.setItem('workoutSetupData', JSON.stringify(state))
    }
  },
});

export const {createWorkoutSetupData} = workoutSetup.actions;
export default workoutSetup.reducer;